import { formatAmount } from 'utils/amountUtils';
import { formatDate } from 'utils/date';
import { statusToText } from 'utils/status-to-text';
import { formatUnits } from 'viem';
import { IDepositExtended } from 'views/types/typeTransaction';

const ReferralDetails: React.FC<{ transaction: IDepositExtended }> = ({
  transaction,
}) => {
  const referralPercentage = transaction?.referralPercentage
    ? 100 * +transaction.referralPercentage
    : 0;

  return (
    <div className="space-y-4">
      <ul className="flex flex-col gap-3">
        <li>
          Type:{' '}
          <span className="font-semibold ml-3 capitalize">
            {`Tier ${transaction.tier ?? '1'} Referral`}
          </span>
        </li>

        <li>
          Referrer:
          <br />
          <p className="ml-4">
            Name:{' '}
            <span className="font-semibold ml-3">
              {transaction?.user?.username || '---'}
            </span>
          </p>
          <p className="ml-4">
            User ID:{' '}
            <span className="font-semibold ml-3">
              {transaction?.user?.coins_fly_id || '---'}
            </span>
          </p>
        </li>

        <li>
          Referral:
          <br />
          <p className="ml-4">
            Name:{' '}
            <span className="font-semibold ml-3">
              {transaction?.referral?.username || '---'}
            </span>
          </p>
          <p className="ml-4">
            User ID:{' '}
            <span className="font-semibold ml-3">
              {transaction?.referral?.coins_fly_id || '---'}
            </span>
          </p>
        </li>

        <li>
          From transaction:{' '}
          <span className="font-semibold ml-3">
            {transaction?.sourceTransactionId || '---'}
          </span>
        </li>

        <li>
          Amount:{' '}
          <span className="font-semibold ml-3">
            {formatAmount(
              formatUnits(
                BigInt(transaction?.amountIn),
                transaction.currencyIn.decimals
              )
            )}{' '}
            {transaction?.currencyIn?.symbol || '---'}
          </span>
        </li>

        <li>
          Commission Rate:{' '}
          <span className="font-semibold ml-3">{`${referralPercentage}%`}</span>
        </li>

        <li>
          Date:{' '}
          <span className="font-semibold ml-3">
            {transaction?.createdAt
              ? formatDate(transaction.createdAt, 'DD.MM.YYYY HH:mm')
              : '---'}
          </span>
        </li>

        {transaction?.completedOrFailedAt && (
          <li>
            Status Changed at:{' '}
            <span className="font-semibold ml-3">
              {formatDate(transaction.completedOrFailedAt, 'DD.MM.YYYY HH:mm')}
            </span>
          </li>
        )}

        <li>
          Status:{' '}
          <span className="font-semibold ml-3 capitalize">
            {statusToText(transaction?.status, transaction?.type)}
          </span>
        </li>

        <li>
          Order: <span className="font-semibold ml-3">{transaction?.id}</span>
        </li>
      </ul>
    </div>
  );
};
export default ReferralDetails;
